import React, { useEffect, useState } from "react";
import Select from "react-select";

function CustomDropDown({
  name,
  register,
  labelTitle,
  placeholder,
  icon,
  setValue,
  showError,
  errorMessage,
  options,
  showMandatory = false,
  defaultOption,
  parentProps,
  resetValue,
  setResetValue,
  isHidden,
  onChange,
  isWhiteTheme = false,
  ...props
}) {
  const [selectedOption, setSelectedOption] = useState(defaultOption);

  useEffect(() => {
    if (resetValue) {
      setResetValue(false);
      if(setValue) setValue(name, null);
      setSelectedOption(null);
    }
  }, [resetValue, isHidden]);

  return (
    !isHidden && (
      <div className="form-group coform-control d-flex flex-column w-100" {...parentProps}>
        <h3 className="fw-600 medium-text mb-0">
          {labelTitle}
          {showMandatory ? <span className="danger">*</span> : null}
        </h3>

        <div className="d-flex flex-column">
          <div className="d-flex gap-2 mt-1">
            <Select
              className="w-100"
              defaultValue={selectedOption}
              maxMenuHeight={200}
              onChange={(e) => {
                if(setValue) setValue(name, e.value, { shouldValidate: true });
                setSelectedOption(e);
                if (onChange) onChange(e);
              }}
              value={selectedOption}
              {...props}
              placeholder={placeholder}
              noOptionsMessage={() => "No Data Available!"}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderWidth: 0,
                  boxShadow: "none",
                  borderColor: "#e2e2e2",
                  background: "transparent",
                }),
                container: (baseStyles, state) => ({
                  ...baseStyles,
                }),
                singleValue: (baseStyles, state) => ({
                  ...baseStyles,
                  color: isWhiteTheme ? "white" : "black",
                }),
                valueContainer: (baseStyles, state) => ({
                  ...baseStyles,
                  padding: "0px",
                  height: 43,
                  borderWidth: 0,
                  border: 0,
                  boxShadow: "none",
                  fontSize: "clamp(16px, 1vw, 18px)",
                  fontWeight: "400",
                }),
                indicatorSeparator: (baseStyles, state) => ({
                  ...baseStyles,
                  display: "none",
                }),
                placeholder: (baseStyles, state) => ({
                  ...baseStyles,
                  color: isWhiteTheme ? "white" : "grey",
                }),
                menu: (baseStyles, state) => ({
                  ...baseStyles,
                  zIndex: 999,
                  clipPath: "padding-box",
                  borderRadius: 6,
                  boxShadow: "0px 0px 10px #0000001A",
                }),
                menuList: (baseStyles, state) => ({
                  ...baseStyles,
                  padding: 0,
                  border: "1px solid #EEEEEE",
                }),
                option: (baseStyles, state) => ({
                  ...baseStyles,
                  padding: "12px 16px",
                  fontWeight: 400,
                  fontSize: 14,
                  borderBottom: "1px solid #EEEEEE",
                }),
                dropdownIndicator: (baseStyles, state) => ({
                  ...baseStyles,
                  color: isWhiteTheme ? "white" : "grey",
                  transition: "color 0.3s ease",
                  "&:hover": {
                    color: isWhiteTheme ? "white" : "grey",
                    cursor: "pointer"
                  },
                }),
              }}
              theme={(theme) => ({
                ...theme,
                borderRadius: 8,
                colors: {
                  ...theme.colors,
                  primary: "#F6821F",
                  primary25: "#F6821F33",
                  primary50: "#F6821F1A",
                },
              })}
              options={options}
            />
          </div>
          <div className={"form-input-bottom-line"} />
        </div>

        {showError ? (
          <span className="danger small-text fw-400 mt-2">{errorMessage}</span>
        ) : null}
      </div>
    )
  );
}

export default CustomDropDown;
